import React, { useState, useEffect } from 'react';
import { Typography, Box, Button } from '@mui/material';
import { useParams } from 'react-router-dom';
import AppDocuServiceCall from './AppDocu/_Utils/AppDocuServiceCall';
import { notifySomething } from './AppDocu/_Utils/AppDocuCommon';
import LoadingSpinner from '../comp/gen/LoadingSpinner';
import UserAuthRequired from '../comp/gen/UserAuthRequired';
import FeasibilityPage from './AppDocu/Feasibility/FeasibilityPage';

const AppDocuFeasibilityPage = (props) => {
  const { com_brand } = useParams();
  const [userState, setUserState] = useState('init');
  const [userCountry, setUserCountry] = useState('');
  const [searchAi, setSearchAi] = useState(false);

  useEffect(() => {
    checkUser();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (userState === 'valid') {
      ///fetchServiceActivities();
    }
  }, [userState]);

  const checkUser = async () => {
    try {
      const res = await AppDocuServiceCall.checkUser();
      //console.log(res.data)
      if (res.data && res.data.is_valid === false) {
        setUserState('notLogged');
      } else {
        setUserState('valid');
        setUserCountry(res.data.country || '');
        setSearchAi(res.data.search_ai || false);
      }
    } catch (error) {
      setUserState('error');
    }
  };
  
  // Compute brand normalization and closestBrand deterministically with hooks
  const validBrands = ["AEB", "LANDI", "LOVATO"];
  const normalizedBrand = com_brand ? com_brand.toUpperCase() : '';
  const isValidBrand = validBrands.includes(normalizedBrand);

  const closestBrand = React.useMemo(() => {
    if (!normalizedBrand) return '';
    if (isValidBrand) return normalizedBrand;
    // Trova il brand più simile (per lunghezza minima di Levenshtein)
    const levenshtein = (a, b) => {
      if (a.length === 0) return b.length;
      if (b.length === 0) return a.length;
      const matrix = [];
      for (let i = 0; i <= b.length; i++) matrix[i] = [i];
      for (let j = 0; j <= a.length; j++) matrix[0][j] = j;
      for (let i = 1; i <= b.length; i++) {
        for (let j = 1; j <= a.length; j++) {
          if (b.charAt(i - 1) === a.charAt(j - 1)) {
            matrix[i][j] = matrix[i - 1][j - 1];
          } else {
            matrix[i][j] = Math.min(
              matrix[i - 1][j - 1] + 1,
              matrix[i][j - 1] + 1,
              matrix[i - 1][j] + 1
            );
          }
        }
      }
      return matrix[b.length][a.length];
    };
    let minDist = Infinity;
    let best = '';
    validBrands.forEach(b => {
      const dist = levenshtein(normalizedBrand, b);
      if (dist < minDist) {
        minDist = dist;
        best = b;
      }
    });
    return best;
  }, [normalizedBrand, isValidBrand]);

  // update document title based on closestBrand
  useEffect(() => {
    document.title = closestBrand ? `Feasibility - ${closestBrand} - ServiceApplications` : 'Feasibility - ServiceApplications';
  }, [closestBrand]);

  if (userState === 'init') return <LoadingSpinner />;
  if (userState === 'error') return <UserAuthRequired text="Loading error." />;
  if (userState === 'notLogged') return <UserAuthRequired redirectToLogin={true} />;
  if (!normalizedBrand) return <UserAuthRequired text={"Com Brand missing."} />;

  const navbarHeightPx = parseInt(props.navbarHeight, 10) || 0;
  const mainBoxStyle = {
  p: 0,
  m: 0,
  width: '100%',
  minHeight: `calc(100vh - ${navbarHeightPx}px)`,
  position: 'relative',
  marginLeft: 0,
  marginRight: 0,
  background: 'transparent',
  boxSizing: 'border-box',
  overflow: 'auto',
  };

  // decide language from userCountry: italian-like => 'it', otherwise 'en'
  const lang = userCountry && /ital/i.test(userCountry) || (userCountry || '').toLowerCase() === 'it' ? 'it' : 'en';

  return (
    <Box sx={mainBoxStyle}>
      <Box sx={{ width: '100%', overflow: 'auto', p: 0 }}>
        <FeasibilityPage 
          navbarHeight={navbarHeightPx + 'px'} 
          comBrand={closestBrand} 
          lang={lang} 
          searchAi={searchAi}
        />
      </Box>
    </Box>
  );
};

export default AppDocuFeasibilityPage;
